import { BookOpen, PersonStanding, Sparkles, Compass, ArrowUpRight } from "lucide-react";
import { Reveal } from "./Motion";
import { useLang } from "@/lib/i18n";

export default function Needs() {
  const { t } = useLang();
  const NEEDS = [
    {
      id: "ecole",
      icon: BookOpen,
      color: "hsl(var(--primary))",
      bg: "hsl(var(--sky))",
      title: t("needs.ecole.title"),
      text: t("needs.ecole.text"),
    },
    {
      id: "bouger",
      icon: PersonStanding,
      color: "hsl(var(--coral))",
      bg: "#FFE5DE",
      title: t("needs.bouger.title"),
      text: t("needs.bouger.text"),
    },
    {
      id: "lien",
      icon: Sparkles,
      color: "hsl(var(--plum))",
      bg: "#EFE7F3",
      title: t("needs.lien.title"),
      text: t("needs.lien.text"),
    },
    {
      id: "creer",
      icon: Compass,
      color: "hsl(var(--accent))",
      bg: "#FFF3C4",
      title: t("needs.creer.title"),
      text: t("needs.creer.text"),
    },
  ];

  return (
    <section id="besoins" className="py-16 md:py-24 bg-background" data-testid="needs-section">
      <div className="max-w-[1400px] mx-auto px-4 md:px-8">
        <Reveal>
          <div className="max-w-3xl">
            <div className="chip">{t("needs.chip")}</div>
            <h2 className="mt-4 font-heading text-3xl md:text-5xl leading-[1.05] text-foreground">
              {t("needs.title_1")}{" "}
              <span className="text-primary">{t("needs.title_today")}</span> ?
            </h2>
            <p className="mt-4 text-lg text-foreground/75 leading-relaxed">
              {t("needs.subtitle")}
            </p>
          </div>
        </Reveal>

        <div className="mt-10 md:mt-14 grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6" data-testid="needs-grid">
          {NEEDS.map((n, i) => (
            <Reveal key={n.id} delay={i * 0.06}>
              <a
                href="#activites"
                data-testid={`need-card-${n.id}`}
                className="group block rounded-3xl p-6 md:p-8 border-2 border-transparent hover:border-foreground/10 transition-all bg-white hover:-translate-y-1 hover:shadow-[0_20px_40px_-20px_rgba(23,49,58,0.25)] focus-visible:outline-primary"
              >
                <div className="flex items-start gap-5">
                  <div
                    className="shrink-0 w-14 h-14 md:w-16 md:h-16 rounded-2xl grid place-items-center"
                    style={{ backgroundColor: n.bg, color: n.color }}
                  >
                    <n.icon className="w-7 h-7 md:w-8 md:h-8" strokeWidth={2.2} />
                  </div>
                  <div className="flex-1">
                    <h3 className="font-heading text-xl md:text-2xl leading-tight text-foreground">
                      {n.title}
                    </h3>
                    <p className="mt-2 text-base leading-relaxed text-foreground/75">{n.text}</p>
                    <div className="mt-4 inline-flex items-center gap-2 text-sm font-bold text-primary group-hover:gap-3 transition-all">
                      {t("needs.cta")}
                      <ArrowUpRight className="w-4 h-4" strokeWidth={2.5} />
                    </div>
                  </div>
                </div>
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
